import { createI18n } from 'vue-i18n';
import * as vuetifyLocales from 'vuetify/locale';

type LocaleKey = keyof typeof vuetifyLocales;

function _mergeLocaleMessage(msgs1: any, msgs2: any) {
  for (const key in msgs2) {
    if (Object.prototype.hasOwnProperty.call(msgs2, key)) {
      const val1IsObj = typeof msgs1[key] === 'object';
      const val2IsObj = typeof msgs2[key] === 'object';
      if (Object.prototype.hasOwnProperty.call(msgs1, key) && val1IsObj && val2IsObj) {
        _mergeLocaleMessage(msgs1[key], msgs2[key]);
      } else {
        msgs1[key] = msgs2[key];
      }
    }
  }
}

export function loadLocaleMessages() {
  const locales = require.context('./locales', true, /\.json$/);
  console.debug('locales', locales.keys());
  const messages: Record<string, any> = {};
  const languageNames: Record<string, string> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/\.\/([a-z]{2})\/([a-zA-Z0-9-_]+)\.json$/);
    if (matched) {
      const locale = matched[1];
      const fileName = matched[2];

      if (!messages[locale]) {
        messages[locale] = {};
      }

      if (fileName === 'index') {
        Object.assign(messages[locale], locales(key));
        const vuetifyMsgs = messages[locale].$vuetify || {};
        const vuetifyDefaultMsgs = vuetifyLocales[locale as LocaleKey];
        _mergeLocaleMessage(vuetifyDefaultMsgs, vuetifyMsgs);
        messages[locale].$vuetify = vuetifyDefaultMsgs;
      } else {
        messages[locale]['file-' + fileName] = locales(key);
      }

      if (fileName === 'index' && messages[locale].languageName) {
        languageNames[locale] = messages[locale].languageName;
      }
    }
  });

  return { messages, languageNames };
}

const { messages, languageNames } = loadLocaleMessages();

export const availableLanguagesKeys = Object.keys(messages);
export const availableLanguagesNames = languageNames;

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  sk: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
};

// Create the i18n instance
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'sk',
  fallbackLocale: localStorage.getItem('lang') || 'sk',
  messages,
  dateTimeFormats,
});

export default i18n;
